export default {"src":"/_next/static/media/ankr.131e39ee.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};